import { useTranslation } from 'react-i18next';
import { getDownloadUrl } from '../lib/constants';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-[#1414131a] dark:border-[#faf9f51a] bg-[#faf9f5] dark:bg-[#141413]">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          {/* Brand + legal */}
          <div className="max-w-xs">
            <div className="font-display display-tight text-lg font-medium text-[#141413] dark:text-[#faf9f5]">
              Cherry Agent
            </div>
            <p className="mt-2 text-sm text-[#6b6a68] dark:text-[#9a9893] leading-relaxed">
              {t('footer.copyright', { year: currentYear })}
            </p>
            <p className="mt-3 text-xs text-[#87867f] leading-relaxed">
              {t('footer.company.operatedBy')}
              <br />
              <a
                href="https://find-and-update.company-information.service.gov.uk/company/16096119"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-2 transition-colors duration-300 hover:text-[#ae5630]"
              >
                {t('footer.company.numberLabel', { number: '16096119' })}
              </a>
            </p>
          </div>

          {/* Links grid */}
          <div className="flex flex-wrap gap-x-16 gap-y-8 text-sm">
            {/* Product */}
            <div>
              <h4 className="mb-4 font-medium text-[#141413] dark:text-[#faf9f5]">
                {t('footer.product')}
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#features"
                    className="text-[#6b6a68] dark:text-[#9a9893] transition-colors duration-300 hover:text-[#ae5630] dark:hover:text-[#ae5630]"
                  >
                    {t('footer.links.features')}
                  </a>
                </li>
                <li>
                  <a
                    href={getDownloadUrl()}
                    className="text-[#6b6a68] dark:text-[#9a9893] transition-colors duration-300 hover:text-[#ae5630] dark:hover:text-[#ae5630]"
                  >
                    {t('footer.links.download')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="mb-4 font-medium text-[#141413] dark:text-[#faf9f5]">
                {t('footer.contact')}
              </h4>
              <ul className="space-y-3">
                <li className="text-[#6b6a68] dark:text-[#9a9893]">
                  <span className="font-medium text-[#141413] dark:text-[#faf9f5]">
                    {t('footer.contactInfo.wechat')}:
                  </span>{' '}
                  JsnonoChat
                </li>
                <li>
                  <a
                    href="mailto:1073634403@qq.com"
                    className="text-[#6b6a68] dark:text-[#9a9893] transition-colors duration-300 hover:text-[#ae5630] dark:hover:text-[#ae5630]"
                  >
                    <span className="font-medium text-[#141413] dark:text-[#faf9f5]">
                      {t('footer.contactInfo.email')}:
                    </span>{' '}
                    1073634403@qq.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/+rF_DXgP1QiQ3Y2Zl"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#6b6a68] dark:text-[#9a9893] transition-colors duration-300 hover:text-[#ae5630] dark:hover:text-[#ae5630]"
                  >
                    Telegram
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom divider + fine print */}
        <div className="mt-10 flex items-center border-t border-[#1414131a] dark:border-[#faf9f51a] pt-6">
          <span className="text-xs text-[#87867f]">
            © {currentYear} Cherry Agent · Made with care
          </span>
          <span className="ml-auto h-1.5 w-1.5 rounded-full bg-[#ae5630]/40" aria-hidden="true" />
        </div>
      </div>
    </footer>
  );
}
